import React, { useState, useEffect } from 'react';
import { LigningIcon } from './LigningIcon'
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './login.css'
import MainLogo from './MainLogo.png';

const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const validateLightningUrl = async (email) => {
  if (!email)
    return false;

  try {
    const [username, domain] = email.split("@");
    const url = `https://${domain}/.well-known/lnurlp/${username}`;
    const res = await fetch(url);
    const data = await res.json();
    return data.callback;
  }
  catch (e) {
    return false;
  }
}

function Login(props) {

  const [email, setEmail] = useState("");
  const [error, setError] = useState();
  const [spinner, setSpinner] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    if (props.email) {
      navigate('/dashboard');
    }
  }, [])

  const submit = () => {
    setError(undefined);

    const isEmail = EMAIL_REGEX.test(email);
    if (!isEmail) {
      setError("Invalid email");
      return;
    }
    setSpinner(true)
    validateLightningUrl(email).then((isValid) => {
      if (isValid) {
        props.setEmail(email);
        navigate('/dashboard');
      }
      else {
        setError("Not recognized as valid Lightning Address")
      }
      setSpinner(false);
    })
  }

  return (
    <div className='login-container'>
      <div className='login-block'>
        <div style={{ textAlign: 'center' }}>
          <LigningIcon height={48} width={48} />
          <div className='logo-text'>
            <img src={MainLogo} style={{ height: '30px' }} alt="logo" />
          </div>
        </div>

        <div style={{ width: '100%' }}>
          <div className='login-input-label'>Lightning Address*</div>

          <Form.Control
            type="text"
            className='login-input'
            id="email"
            key='email'
            aria-describedby="email"
            placeholder="Your lightning address"
            onChange={(e) => { setEmail(e.target.value) }}
          />
          {
            error && (<div style={{ padding: '6px 0', fontSize: "12px" }}>{error}</div>)
          }
        </div>

        <Button
          style={{ backgroundColor: 'rgba(52, 82, 244, 1)', width: '100%' }}
          onClick={submit}>
          {spinner ? "Entering..." : "Enter"}
        </Button>{' '}
      </div>
    </div>
  )
}

export default Login;